export enum CompanyContactType {
  StandardTraveller = 0,
  GroupsOnlyTraveller = 1,
  Other = 2
}

export const companyContactTypeLabels: Record<CompanyContactType, string> = {
  [CompanyContactType.StandardTraveller]: 'Standard Traveller',
  [CompanyContactType.GroupsOnlyTraveller]: 'Groups Only Traveller',
  [CompanyContactType.Other]: 'Other'
};
